/**
 * Add a simple ripple effect to chosen elements
 * @param {DOMElement} context - Where should search be contained too.
 * @param {CSSRule} selector - The element/s to look for
 * 
 * @example
 * setupRippleEffect(document.body, '.js-ripple');
 */
export const setupRippleEffect = (context:HTMLElement, selector:string[]) => {

    const noJsRippleSuffix = ':not(.no-js-ripple)';
    (<NodeListOf<HTMLElement>>context.querySelectorAll(selector.join(noJsRippleSuffix + ',') + noJsRippleSuffix))
        .forEach(rippleElm => {
            if (rippleElm.closest('.nav-drawer')) return;

            rippleElm.style.position = "relative";

            const rippleDiv = document.createElement('div');
            rippleDiv.classList.add('rippleJS');
            rippleElm.appendChild(rippleDiv);
        });
};